import { OperatingHours } from '@leverege/operating-hours'
import { useSharedContext } from '@leverege/ui-plugin'
import { DateTime } from 'luxon'
import { useMemo } from 'react'

import { Attributes } from '@leverege/ui-attributes'
import { getOpenAndCloseTimesFromHours, getOpenHoursFromOperatingHours } from '../../../../../util'

export default function useBarData( {
  data,
  stationNames
} ) {
  const { timezone, operatingHours } = useSharedContext()

  return useMemo( () => {
    const openHours = getOpenHoursFromOperatingHours( operatingHours, false )
    const lookup = data.reduce( ( prev, datum ) => {
      const { startTime, obj } = datum
      let date = DateTime
        .fromMillis( startTime )
        .setZone( timezone )
      const hoursForDate = OperatingHours.getHoursForDate( operatingHours )

      if ( hoursForDate && hoursForDate.open ) {
        const { open, close } = getOpenAndCloseTimesFromHours( hoursForDate, date, timezone )
        if ( date < open ) {
          date = date.plus( { hour : 1 } )
        }

        if ( date > close ) {
          date = date.minus( { hour : 1 } )
        }

        const hour = `${date.hour}`
        const number = obj?.data?.data?.number

        const formattedStart = DateTime.now().set( { hour } ).startOf( 'hour' ).toFormat( 'hh:mma' )
        const formattedEnd = DateTime.now().set( { hour : Number( hour ) + 1 } ).startOf( 'hour' ).toFormat( 'hh:mma' )
        const formattedHour = `${formattedStart} - ${formattedEnd}`

        const name = Attributes.get( 'name', obj ) || obj.data?.name
  
        if ( number != null ) {
          if ( prev[hour] ) {
            if ( prev[hour][name] ) {
              prev[hour][name] += 1
            } else {
              prev[hour][name] = 1
            }
  
            prev[hour].count += 1
          } else {
            prev[hour] = {
              hour,
              count : 1,
              [name] : 1,
              formattedHour
            }
          }
        }
      }
  
      return prev
    }, {} )
  
    openHours.forEach( ( hourKey ) => {
      if ( !lookup[hourKey] ) {
        lookup[hourKey] = {
          count : 0,
          hour : hourKey
        }
      }

      stationNames.forEach( ( stationKey ) => {
        if ( !lookup[hourKey][stationKey] ) {
          lookup[hourKey][stationKey] = 0
        }
      } )
    } )
  
    return Object.values(
      lookup
    )
  }, [ data, operatingHours, timezone, stationNames ] )
}
